import React from "react";
import "./Hero.css";

const Hero = () => {
  const scrollToMenu = () => {
    const element = document.getElementById("menu");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/hero.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
    overflow: "hidden",
  };

  return (
    <section id="home" className="hero" style={heroStyle}>
      <div className="hero-content">
        <h2>Welcome to Nanglo Momos & Curry</h2>
        <p>Experience the authentic flavors of the Himalayas</p>
        <div className="hero-info">
          <p>
            <i className="fas fa-map-marker-alt"></i> 1410 Indiana Ave,
            Sheboygan, WI 53081
          </p>
          <p>
            <i className="fas fa-phone"></i> (920) 316-2253
          </p>
        </div>
        <button className="cta-button" onClick={scrollToMenu}>
          View Menu
        </button>
      </div>
    </section>
  );
};

export default Hero;
